import Loadable from "app/components/Loadable";
import { lazy } from "react";

const FishFarmVisitList = Loadable(lazy(() => import("./FishFarmVisitList")));
const FishFarmVisitForm = Loadable(lazy(() => import("./FishFarmVisitForm")));

const fishFarmVisitRoutes = [
  {
    path: "/FishFarmVisit/FishFarmVisitList",
    element: <FishFarmVisitList />,
  },
  {
    path: "/FishFarmVisit/FishFarmVisitForm",
    element: <FishFarmVisitForm />,
  },
  {
    path: "/FishFarmVisit/FishFarmVisitForm/:fishFarmVisitId",
    element: <FishFarmVisitForm />,
  },
];

export default fishFarmVisitRoutes;
